module.exports = __webpack_public_path__ + "static/media/point-3.2ced6127.svg";